// Sort ids shared by the dimension lists (sidebar, column browser, lens table).
// A leaf module with no imports, so dimensionDefs.js, apiClient.js and the dim
// adapters can share it without touching the dimAdapters.js import cycle.

// Fewest-first twin of the default "activity" sort (trace count, descending).
export const SORT_FEWEST = "activity_asc";

// Order for lists ranked in the browser (dim adapters, array-dim
// re-aggregation). Mirrors the server order in executeDimensionEntries: count,
// then name, so ties stay in a stable A-Z order across pages. Sorts it does not
// rank (tokens, recent) fall back to most-first, as the server path does.
export function compareDimEntries(sort) {
  const byName = (a, b) => String(a.label ?? a.id ?? "").localeCompare(String(b.label ?? b.id ?? ""));
  if (sort === "name") return byName;
  const dir = sort === SORT_FEWEST ? 1 : -1;
  return (a, b) => dir * ((Number(a.value) || 0) - (Number(b.value) || 0)) || byName(a, b);
}
